import {
  PositionBalance,
  PositionType,
} from '~/components/smart-accounts/positions/types'
import { PositionClaimData } from '~/types'

export const getPositionTypeLabel = (positionType: PositionType) => {
  switch (positionType) {
    case 'clanker':
      return 'Clanker'
    case 'uniswap-v3':
      return 'Uniswap'
    case 'uniswap-v4':
      return 'Uniswap'
    default:
      return 'Position'
  }
}

export const getPositionClaimTitle = (position: PositionBalance) => {
  const label = getPositionTypeLabel(position.positionType)

  return `Claim ${label} rewards`
}

export const buildPositionClaimData = ({
  positionBalance,
  chainId,
}: {
  positionBalance: PositionBalance
  chainId: number
}): PositionClaimData => ({
  tokenPositions: positionBalance.tokens.map((token) => ({
    tokenAddress: token.address,
    tokenAmount: token.claimableAmount.toString(),
    chainId,
  })),
  protocol: positionBalance.positionType,
})
